// 沿線・駅から探すモーダル
const ModalSearchSave = {
  namespaced: true,

  state: {
    modal: false,
    search: {},
    tag: {},
  },
  getters: {
    getModal: state => {
      return {
        modal: state.modal,
        search: state.search,
        tag: state.tag,
      }
    },
  },
  mutations: {
    setModal(state, search) {
      state.modal = search.modal
      state.search = search.search
      state.tag = search.tag
    },
  },
  actions: {},
}

export default ModalSearchSave
